import React, { Component } from 'react';
import {retrieveAllBackups, restore} from "../../util/ApiUtils";
import {Route} from "react-router-dom";
import {ACCESS_TOKEN, V1_API_URL_PREFIX} from "../../Constants";
import {NotificationManager} from "react-notifications";
import {getClientsForAdmin} from "../../util/ApiUtils";
import MenuItem from "@material-ui/core/MenuItem";

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fileNames: [],
            message: null
        };
        this.getClients = this.getClients.bind(this);
    }


    componentDidMount() {
        this.getClients();
    }

    getClients() {
        this.setState({
            isLoading: true
        });
        getClientsForAdmin()
            .then(response => {
                console.log('response', response);
                this.setState({
                    clients: response,
                    isLoading: false
                });
            }).catch(error => {
            console.log('error', error);
            this.setState({
                isLoading: false
            });
        });
    }

    submit() {
        let companyname = document.getElementById("companyname");
        let trial_end_date = document.getElementById("trial_end_date");
        if (
            companyname && companyname.value !== ''
        ) {
            const headers = new Headers({
                'Content-Type': 'application/json',
            });

            if (localStorage.getItem(ACCESS_TOKEN)) {
                headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
            }

            const defaults = {headers: headers};
            let options = Object.assign({}, defaults, {
                url: V1_API_URL_PREFIX + "/admin/migrate-client",
                method: 'POST',
                body: JSON.stringify({
                    companyname: companyname.value,
                    trial_end_date: trial_end_date.value,

                })
            });
            return fetch(options.url, options)
                .then(response => {
                        if (response.status !== 200) {
                            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
                            return Promise.reject();
                        }
                        document.getElementById("companyname").value = "";
                        document.getElementById("trial_end_date").value = "";
                        NotificationManager.success('Success', 'The client has ben deactivated.', 5000);
                        return Promise.resolve();
                    }
                );
        } else {
            console.log("invalid");
            NotificationManager.error('Error', 'Please enter all required fields', 5000);
        }
    }

    render() {
        return (
            <Route path={`/admin/migrate-client` }>
            <div className="container" style={{ textAlign: "center" }}>
                <h3>Update An Existing Client</h3>
                <div className="container">
                    <table className="table" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <tbody style={{ textAlign: "right"}}>
                        <tr>
                            <td>Company Name (Must be an existing name) <span style={{ color: "red" }}>*</span></td>
                            <td><input type="text" name="companyname" id="companyname"/></td>
                        </tr>
                        <tr>
                            <td style={{ width: "400px"}}>Trial END date dd/mm/yyyy (leave black for end trial and give client full permission), date has to be in past if you want to terminate client immediately</td>
                            <td><input type="text" name="trial_end_date" id="trial_end_date"/></td>
                        </tr>
                        <tr style={{ textAlign: "left"}}>
                            <td></td>
                            <td><button type="submit" onClick={ this.submit }>UPDATE CLIENT</button></td>
                        </tr>
                        </tbody>
                    </table>
                    <span>List of existing clients</span>
                    {this.state.clients && this.state.clients.map(function(item) {
                        console.log('item', item);
                        return <React.Fragment><span id={item.id}>{item.name}</span><br/></React.Fragment>;
                    })}
                </div>
            </div>
            </Route>
        )
    }
}

export default Admin;